// Central place to store per-page metadata such as titles without using global stores
// Works per-tab since it is in-memory per page load

const titleMap = {};

export function setPageMetaTitle(name, title) {
  if (name && title) {
    titleMap[name] = title;
  }
}

export function getPageMetaTitle(name) {
  return name ? titleMap[name] : undefined;
}
